<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import menus from '@/config/menus'
import Gravatar from 'vue-gravatar'

export default {
  components: { Gravatar },
  props: ['activeMenu', 'staticMenu'],
  data: () => ({
    actives: 0,
    menus,
    relCtrl: {
      open: false
    }
  }),
  computed: {
    ...mapState('auth', {
      usuario: 'usuario'
    }),
    ...mapGetters('auth', {
      relatorios: 'relatorios'
    }),
    actMenu: {
      get: function () {
        return this.activeMenu
      },
      set: (val) => val
    },
    menuPosition: {
      get: function () {
        return this.staticMenu
      },
      set: function (val) {
        this.$emit('monitorarSwitch', val)
      }
    }
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
      validaSenhaAsync: 'auth/validaSenhaAsync',
      toaster: 'modal/toaster',
      openRelatorio: 'relatorio/open'
    }),
    async chamarLogout () {
      await this.logout()
      location.href = '/out/login'
    },
    chamarRota (tela) {
      if (tela.habilitado) {
        this.actives = tela.id
        this.$emit('ocultarMenu')
        this.$router.push(tela.web_url)
      } else this.toaster({ message: 'Acesso não permitido!', color: 'error' })
    },
    async validaPermissaoRelatorio (item) {
      try {
        if (item.acesso.pedir_senha) await this.validaSenhaAsync({ funcionalidade: item.funcionalidade_identificacao })
        if (!item.acesso.pedir_senha && !item.acesso.habilitado) throw new Error('Funcionalidade não habilitada!')
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
        throw e
      }
    },
    abreListRelatorio (relatorio) {
      this.$refs.modalRelatorios.open(relatorio.itens)
    },
    async abreRelatorio (item) {
      await this.validaPermissaoRelatorio(item)
      await this.openRelatorio(item.id)
    }
  }
}
</script>

<template>
  <div class="parentx-static">
    <vs-sidebar default-index="1.1" color="primary" class="sidebarx" spacer v-model="actMenu" :static-position="menuPosition">
      <div class="header-sidebar" slot="header">
        <!-- <vs-avatar size="70px" src="https://randomuser.me/api/portraits/men/78.jpg" /> -->
             <Gravatar class="avatar" :email="usuario.email" :alt="usuario.nome" default-img="mm"/>
        <h4>
          {{usuario.nome}}
          <v-tooltip bottom v-show="!activeMenu">
            <v-btn icon flat slot="activator" color="primary" @click="chamarLogout()">
              <v-icon>https</v-icon>
            </v-btn>
            <span>Logout (sair)</span>
          </v-tooltip>
        </h4>
      </div>
      <span v-for="menu in menus" :key="menu.sequencia">
        <vs-sidebar-group :title="menu.descricao" :open="menu.open">
          <vs-sidebar-item v-for="submenu in menu.telas" :key="submenu.sequencia" @click="chamarRota(submenu)" :active="actives==submenu.id" :index="submenu.id">
              <i v-if="submenu.icone" :class="`fa fa-${submenu.icone}`"/> &nbsp; {{ submenu.descricao }}
          </vs-sidebar-item>
        </vs-sidebar-group>
      </span>
      <span>
        <vs-sidebar-group v-if="relatorios.length > 0 " title="Relatórios" :open="relCtrl.open">
          <vs-sidebar-item v-for="(rel, indice) in relatorios" :key="indice" @click="abreListRelatorio(rel)" :active="false">
              {{ rel.descricao }}
          </vs-sidebar-item>
        </vs-sidebar-group>
      </span>
      <ui-modal-relatorios ref="modalRelatorios" @escolhe="abreRelatorio" />
      <div class="footer-sidebar" slot="footer">
        <vs-button vs-icon="reply" color="danger" vs-type="flat" @click="chamarLogout()">Sair</vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<style>
.avatar {
  margin-top: 5px;
  width: 70px !important;
  height: 70px !important;
  float: right;
  margin-right: 5px;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
  border-radius: 100px;
}

</style>
